import { render, staticRenderFns } from "./LastSearchs.vue?vue&type=template&id=b10d6d24&"
import script from "./LastSearchs.vue?vue&type=script&lang=js&"
export * from "./LastSearchs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports